import { Colors } from '../_declarations/colors';

const colors: Colors = {
  background0: '#FFFFFF',
  background1: '#F7F7F7',
  background2: '#ECECEE',
  background3: '#ADAEB2',
  background4: '#787B80',
  background5: '#0064CF',
  background6: '#000000',
  backgroundBlack: '#000000',
  backgroundWhite: '#FFFFFF',
  // Brand
  black: '#000000',
  blackBottom: 'linear-gradient(0deg, #000000 0%, rgba(28, 31, 42, 0) 100%)',
  blackImage45:
    'linear-gradient(76.37deg, rgba(0, 0, 0, 0.519541) 33.03%, rgba(28, 31, 42, 0.6) 33.03%, rgba(0, 0, 0, 0) 72.57%)',

  // Gradient colors
  blackLeft: 'linear-gradient(90deg, #000000 0%, rgba(28, 31, 42, 0) 100%)',
  blackRight: 'linear-gradient(270deg, #000000 0%, rgba(28, 31, 42, 0) 100%)',
  blackTop: 'linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #1C1F2A 100%)',
  blurredGray: 'rgba(92, 92, 92, 0.5)',
  blurredWhite: 'rgba(255, 255, 255, 0.5)',
  blurredWhiteLight: 'rgba(255, 255, 255, 0.1)',

  brand1: '#005187',
  brand2: '#C20E1A',
  brand3: '#BFDD0B',
  brand4: '#E0E622',
  carbon: 'rgba(0, 0, 0, 0.62)',

  dark1Default: '#FFFFFF',
  dark1Disabled: '#787B80',
  dark1Hover: '#F4F4F4',

  dark2Default: '#FFFFFF',
  dark2Disabled: '#787B80',
  dark2Hover: '#F4F4F4',

  darkAccentDefault: '#C20E1A',
  darkAccentDisabled: '#787B80',
  darkAccentHover: '#b32a1f',

  error: '#EB143D',
  errorBkg: 'rgba(235, 20, 61, 0.2)',
  footer: '#FFFFFF',
  header: '#FFFFFF',
  iconColor: '#FFFFFF',
  imagePlaceholder: '',

  // States
  info: '#0064CF',
  infoBkg: 'rgba(0, 123, 255, 0.2)',

  // Primary
  light1Default: '#000000',
  light1Disabled: '#ADAEB2',
  light1Hover: '#292B35',

  // Secondary & Tertiary
  light2Default: '#000000',
  light2Disabled: '#ADAEB2',
  light2Hover: '#292B35',

  // Accent
  lightAccentDefault: '#C20E1A',
  lightAccentDisabled: '#ADAEB2',
  lightAccentHover: '#b32a1f',

  // Neutral
  neutral100: '#F7F7F7',

  neutral200: '#ECECEE',
  neutral300: '#CED4DA',
  neutral400: '#787B80',

  neutral500: '#000000',
  neutral600: '#000000',
  overlayBlack: 'rgba(0, 0, 0, 0.64)',

  // Background

  pageDarkMode: '#000000',
  pageLightMode: '#FFFFFF',

  // Sticky Footer
  priceAndText: '#000000',
  secondaryText: '#787B80',
  stickyFooter: '#FFFFFF',
  success: '#1D5B40',
  successBkg: 'rgba(29, 91, 64, 0.2)',

  // Text
  textBody: '#787B80',

  textBodyInverse: '#ECECEE',
  textDark: '#000000',

  textDark1Default: '#000000',
  textDark1Disabled: '#ADAEB2',
  textDark1Hover: '#292B35',

  textDark2Default: '#FFFFFF',
  textDark2Disabled: '#ADAEB2',
  textDark2Hover: '#F4F4F4',

  textDarkAccentDefault: '#FFFFFF',
  textDarkAccentDisabled: '#C4C4C4',
  textDarkAccentHover: '#FFFFFF',

  textDealerToolMenu: '#F7F7F7',

  textHeading: '#000000',
  textHeadingInverse: '#F7F7F7',
  textLight: '#FFFFFF',

  textLight1Default: '#FFFFFF',
  textLight1Disabled: '#787B80',
  textLight1Hover: '#FFFFFF',

  textLight2Default: '#000000',
  textLight2Disabled: '#787B80',
  textLight2Hover: '#292B35',

  textLightAccentDefault: '#FFFFFF',
  textLightAccentDisabled: '#787B80',
  textLightAccentHover: '#FFFFFF',

  warning: '#B32A1F',
  warningBkg: 'rgba(255, 92, 0, 0.2)',
  white: '#FFFFFF',
  whiteBottom:
    'linear-gradient(0deg, #DEDEDE 0%, rgba(222, 222, 222, 0) 65.62%)',
  whiteImage45:
    'linear-gradient(76.37deg, rgba(222, 222, 222, 0.6) 33.03%, rgba(222, 222, 222, 0.42) 33.03%, rgba(222, 222, 222, 0) 72.57%)',
  whiteLeft:
    'linear-gradient(90deg, #DEDEDE 32.81%, rgba(222, 222, 222, 0.53) 73.96%, rgba(222, 222, 222, 0) 100%)',
  whiteRight:
    'linear-gradient(270deg, #DEDEDE 36.46%, rgba(222, 222, 222, 0.42) 71.87%, rgba(222, 222, 222, 0) 100%);',
  whiteTop: 'linear-gradient(0deg, rgba(222, 222, 222, 0) 30.21%, #DEDEDE 100%)'
};

export default colors;
